import React from "react";
import * as FaIcons from "react-icons/fa";

import * as MdIcons from "react-icons/md";

export const EntitySidebarData = [
  {
    title: "Categories",
    id: "spy2",
    to: "table",
    cName: "nav-text",
    icon: <MdIcons.MdCategory />,
    display: true,
    canToggle: false,
  },
  {
    title: "Recommendations",
    id: "spy3",
    to: "recommend",
    cName: "nav-text",
    icon: <MdIcons.MdRecommend />,
    display: true,
    canToggle: false,
  },
  {
    title: "Search Employees",
    id: "spy4",
    to: "empSearch",
    cName: "nav-text",
    icon: <FaIcons.FaSearch />,
    display: true,
    canToggle: false,
  },
  {
    title: "Employee Details",
    id: "spy5",
    to: "empDetails",
    cName: "nav-text",
    icon: <FaIcons.FaUserAlt />,
    display: false,
    canToggle: true,
  },
];
